import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";


const styles = createUseStyles({
  modalContent: {
    margin: "22px 0 0 0"
  },
  mainModalDiv: {
    boxShadow: "inset 0 0 0 1000px rgba(0,0,0,.4)"
  },
  modal: {
    width: "480px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    },
    "& .modal-content":{
      padding:"24px",
    },
    "& .modal-body":{
      padding: "0px"
    },
    "& .modal-header":{
      padding:"0px",
      "& div": {
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "30px",
        right: "30px"
      }
    },
  },
  disableClose: {
    "& .btn-close": {
      pointerEvents: "none"
    }
  },
  description: {
    fontSize: "14px",
    marginBottom: "20px"
  },
  dropzone: {
    marginBottom: "0",
    details: {
      margin: "20px"
    }
  },
});

export default styles;
